(function () {
  function initSlider(root) {
    if (!root || root.dataset.ipReady === 'true') return;
    var track = root.querySelector('[data-ip-track]');
    var slides = root.querySelectorAll('[data-ip-slide]');
    var previous = root.querySelector('[data-ip-prev]');
    var next = root.querySelector('[data-ip-next]');
    var counter = root.querySelector('[data-ip-counter]');
    var thumbs = root.querySelectorAll('[data-ip-thumb]');
    if (!track || !slides.length) return;
    var index = 0;

    function show(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      if (counter) counter.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      thumbs.forEach(function (thumb, thumbIndex) {
        thumb.setAttribute('aria-current', thumbIndex === index ? 'true' : 'false');
      });
    }

    if (previous) previous.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    thumbs.forEach(function (thumb, thumbIndex) {
      thumb.addEventListener('click', function () { show(thumbIndex); });
    });
    root.dataset.ipReady = 'true';
    show(0);
  }

  function initFaq(root) {
    if (!root || root.dataset.ipReady === 'true') return;
    root.querySelectorAll('[data-ip-faq-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('[data-ip-faq-button]').forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
          var panel = document.getElementById(other.getAttribute('aria-controls'));
          if (panel) panel.hidden = true;
        });
        if (!expanded) {
          button.setAttribute('aria-expanded', 'true');
          var panel = document.getElementById(button.getAttribute('aria-controls'));
          if (panel) panel.hidden = false;
        }
      });
    });
    root.dataset.ipReady = 'true';
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ip-slider]').forEach(initSlider);
    (scope || document).querySelectorAll('[data-ip-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
